// extracted by mini-css-extract-plugin
export var readonly = "_dk-1";
export var star = "_dk-0";